<template>
  <div
    class="academy-dash"
    :class="{ 'academy-dash--mobile': isMobile }"
  >
    <header class="ad-head">
      <div class="ad-title">
        <div class="ad-tile">
          <v-icon
            size="22"
            color="primary"
          >
            mdi-school-outline
          </v-icon>
        </div>
        <div class="ad-title-text">
          <div class="ad-title-main">
            {{ $t('academyDashboard') }}
          </div>
          <div class="ad-title-sub">
            {{ $t('academyDashboardHint') }}
          </div>
        </div>
      </div>
      <shortcut class="ad-head-shortcuts" />
    </header>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      color="primary"
      height="2"
    />
    <div class="ad-body">
      <v-form
        v-if="render"
        ref="form"
        v-model="valid"
        class="ad-card"
        lazy-validation
      >
        <calender
          type-prop="category"
          :height-prop="layout.calendarHeight"
        />
      </v-form>
    </div>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import General from '../../../../Mixins/general'
  import Calender from './partial/dashboardCalender'
  import Shortcut from './partial/dashboardShortcut'
  import Snakbar from '../../components/general/snakbar/snakbar'
  export default {
    name: 'AcademyDashboard',
    components: {
      Snakbar,
      Shortcut,
      Calender,
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      tag: null,
      render: false,
      isLoading: false,
      number: 1,
      menu2: null,
      menu1: null,
      duration: '01:00',
      startTime: '12:00',
      amount: null,
      sessionCount: null,
      teacherCost: null,
      teacher: null,
      start: null,
      end: null,
      events: null,
      category: null,
      place: null,
      days: null,
      daysList: null,
      checkNumber: null,
      startDate: null,
      name: null,
      valid: null,
      numberRules: [
        v => !!v || 'This field is required',
        v => (v && v >= 0) || 'The number must be bigger than zero',
      ],
      timer: 0,
      message: null,
      id: null,
      loading: false,
    }),
    watch: {
      snakbar () {
      },
      category (val, oldVal) {
        if (val) {
          if (!this.name) {
            this.name = val.name + '-' + this.number
          }
        }
        if (!this.tag && val.tags) {
          this.tag = val.tags
        }
      },
    },
    created () {
      // UI-only state kept out of data(): create()/update() post this.$data
      this.layout = Vue.observable({ calendarHeight: 600 })
      this.onResize = () => {
        // 98 app chrome, header, body padding, card border, calendar toolbar (44)
        const chrome = this.isMobile ? 56 + 124 + 96 : 98 + 64 + 24 + 2 + 46
        this.layout.calendarHeight = Math.max(320, window.innerHeight - chrome)
      }
      this.onResize()
      window.addEventListener('resize', this.onResize)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
        this.getEventNumber()
      }
      this.daysList = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
    },
    mounted () {
    },
    methods: {
      allowedStep: m => m % 5 === 0,
      getDayNumber (day) {
        var number
        switch (day) {
          case 'Saturday':
            number = 1
            break
          case 'Sunday':
            number = 2
            break
          case 'Monday':
            number = 3
            break
          case 'Tuesday':
            number = 4
            break
          case 'Wednesday':
            number = 5
            break
          case 'Thursday':
            number = 6
            break
          case 'Friday':
            number = 7
            break
        }
        return number
      },
      review () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            checkEvent: 'active',
            name: app.name,
            days: app.days,
            startDate: app.startDate,
            startTime: app.startTime,
            duration: app.duration,
            sessionCount: app.sessionCount,
            teacher: app.teacher,
            teacherCost: app.teacherCost,
            color: app.colors[app.rnd(0, app.colors.length - 1)],
            place: app.place,
          },
        })
          .then(res => {
            res = res.data
            app.events = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'academyEvents', app.$data)
          .then(res => {
            // app.goTo('academyEventList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      getEventNumber () {
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              id: app.id,
              number: app.number,
              select: 'academyGetNumberEvent',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.number = res.number
              }
              app.checkNumber = true
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        this.loading = false
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academyEvents/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.name = res.name
              app.amount = res.amount
              app.number = res.number
              app.teacher = res.teacher
              app.teacherCost = res.teacher_cost
              app.place = res.place
              app.startDate = res.start_date
              app.startTime = res.start_time
              app.duration = res.duration
              app.duration = res.duration
              app.sessionCount = res.session_count
              app.category = res.category
              app.days = res.arrayDays
              app.tag = res.tags
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'academyEvents/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            // app.goTo('academyEventList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped lang="scss">
.academy-dash {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 98px);
  background: #f3f7fc;
  border: 1px solid rgba(15, 23, 42, .08);
  border-radius: 6px;
  overflow: hidden;
}
.ad-head {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 64px;
  padding: 10px 16px;
  background: #fff;
  border-bottom: 1px solid rgba(15, 23, 42, .07);
}
.ad-title {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.ad-tile {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(25, 118, 210, .1);
}
.ad-title-main { font-weight: 600; font-size: .95rem; }
.ad-title-sub { font-size: .78rem; opacity: .6; }
.ad-body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 12px;
  overflow: hidden;
}
.ad-card {
  height: 100%;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, .08);
  border-radius: 6px;
  overflow: hidden;
}

/* Restyle the shared calendar from outside only */
.academy-dash ::v-deep {
  .v-input { height: auto !important; }
  .v-calendar { border: 0 !important; }
  .v-calendar-daily__head { flex-shrink: 0; }
  .v-calendar-daily_head-day, .v-calendar-category__column-header { padding-top: 4px; }
  .v-calendar-daily__head,
  .v-calendar-category__column-header { background: #f8fafd; }
  .v-present .v-calendar-daily_head-day-label .v-btn {
    background: rgba(25, 118, 210, .12) !important;
    color: var(--v-primary-base, #1976d2) !important;
  }
  .v-event, .v-event-timed { border-radius: 6px !important; }
}

.academy-dash--mobile {
  height: auto;
  min-height: calc(100vh - 56px);
  border: 0;
  border-radius: 0;
  .ad-head {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 12px;
  }
  .ad-body { padding: 8px; }
}

.theme--dark {
  .academy-dash { background: #121212; border-color: rgba(255, 255, 255, .08); }
  .ad-head, .ad-card { background: #1e1e1e; border-color: rgba(255, 255, 255, .08); }
  .ad-tile { background: rgba(100, 181, 246, .14); }
  .academy-dash ::v-deep {
    .v-calendar-daily__head,
    .v-calendar-category__column-header { background: #242424; }
  }
}
</style>
